import request from '@/api/config.js'

/**
 * Регистрация нового пользователя
 * @param {Object} data - данные пользователя (email, password, phone, name)
 * @returns {Promise} - промис с результатом регистрации
 */
export function register(data) {
  return request({
    url: `auth/register`,
    method: 'post',
    data,
  }).then((response) => response.data)
}

/**
 * Проверка существования поля в базе данных
 * @param {string} field - название поля (email, phone)
 * @param {string} value - значение для проверки
 * @returns {Promise} - промис с результатом проверки
 */
export function checkFieldExists(field, value) {
  return request({
    url: `auth/check-field`,
    method: 'post',
    data: { field, value },
  }).then((response) => response.data)
}

/**
 * Вход пользователя в систему
 * @param {Object} data - данные для входа (phone, password)
 * @returns {Promise} - промис с токенами и данными пользователя
 */
export function login(data) {
  return request({
    url: `auth/login`,
    method: 'post',
    data,
  }).then((response) => response.data)
}

/**
 * Выход пользователя из системы
 * @param {Object} data - данные с refreshToken
 * @returns {Promise} - промис с результатом выхода
 */
export function logout(data) {
  return request({
    url: `auth/logout`,
    method: 'post',
    data,
  }).then((response) => response.data)
}

/**
 * Генерация кода восстановления пароля
 * @param {Object} data - данные с email пользователя
 * @returns {Promise} - промис с результатом генерации кода
 */
export function generateRecoveryCode(data) {
  return request({
    url: `auth/generateRecoveryCode`,
    method: 'post',
    data,
  }).then((response) => response.data)
}

export function generateRecoveryCodeEmail(data) {
  return request({
    url: `auth/generateRecoveryCodeEmail`,
    method: 'post',
    data,
  }).then((response) => response.data)
}

/**
 * Проверка кода восстановления пароля
 * @param {Object} data - данные с email и кодом
 * @returns {Promise} - промис с результатом проверки кода
 */
export function verifyRecoveryCode(data) {
  return request({
    url: `auth/verifyRecoveryCode`,
    method: 'post',
    data,
  }).then((response) => response.data)
}

/**
 * Сброс пароля по коду восстановления
 * @param {Object} data - данные с email, кодом и новым паролем
 * @returns {Promise} - промис с результатом сброса пароля
 */
export function resetPassword(data) {
  return request({
    url: `auth/resetPassword`,
    method: 'post',
    data,
  }).then((response) => response.data)
}

/**
 * Получение данных текущего пользователя по access token
 * @returns {Promise} - промис с данными пользователя
 */
export function me() {
  return request({
    url: `auth/me`,
    method: 'get',
  }).then((response) => response.data)
}

/**
 * Обновление токена доступа
 * @param {Object} data - данные с refreshToken
 * @returns {Promise} - промис с новым токеном доступа
 */
export function refresh(data) {
  return request({
    url: `auth/refresh`,
    method: 'post',
    data,
  }).then((response) => response.data)
}

/**
 * Смена пароля через личный кабинет
 * @param {Object} data - данные с текущим паролем, новым паролем и ID пользователя
 * @returns {Promise} - промис с результатом смены пароля
 */
export function changePassword(data) {
  return request({
    url: `auth/change-password`,
    method: 'post',
    data,
  }).then((response) => response.data)
}

/**
 * Замена временного пароля (после приглашения сотрудника) на постоянный.
 * Доступно только пока у пользователя mustChangePassword = true.
 * @param {Object} data - { newPassword }
 * @returns {Promise} - промис с результатом
 */
export function setPassword(data) {
  return request({
    url: `auth/password`,
    method: 'patch',
    data,
  }).then((response) => response.data)
}
